import settingsData from '../data/settings.json';
import openingHoursData from '../data/openingHours.json';

export const getSettings = async () => settingsData;
export const getOpeningHours = async () => openingHoursData;